import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetCommentsForOrderId(orderId) {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/Order/Comments?orderId=${orderId}`,
    {
      onSuccess: (data) =>
        console.log("All Comments fetched successfully:", data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    },
  );

  const allComments = data?.data?.map((x) => ({
    comment: x.comment,
    name: x.name,
    date: x.date,
  }));

  return {
    allComments,
    error,
    mutate,
    isLoading,
  };
}
